import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "devicetype-packetparser"
  }, [_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VExpansionPanels, {
    staticClass: "my-4 dt-card-text-01",
    attrs: {
      "value": undefined,
      "flat": ""
    }
  }, [_c(VExpansionPanel, {
    staticClass: "elevation-0"
  }, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.quickReferenceHeader')) + "\n            ")])]), !_vm.callFromDeviceType ? _c(VExpansionPanelContent, [_c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DeviceDriver.quickReference.functionHelpTextJSParser'))
    }
  }), _c('div', [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("module.exports = function (payload, meta) {\n    const port = meta.lora.fport;\n\n    const buf = Buffer.from(payload, 'hex');\n    const battery = buf.readUInt16BE(0);  // parse 2 bytes with offset 0\n    const temperature = buf.readFloatBE(2); // parse 4 bytes with offset 2\n\n    return {\n      battery: battery,\n      temperature: temperature,\n      port: port,\n      raw: payload\n    };\n  }\n\n  /*\n  Example payload: \"002B406EA710\"\n  Output:\n  {\n    \"battery\": 43,\n    \"temperature\": 3.7289466857910156,\n    \"raw\": \"002B406EA710\",\n    \"port\": 1\n  }\n  */")])], 1), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DeviceDriver.quickReference.functionHelpTextExParser1'))
    }
  }), _c('div', [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("defmodule Parser do\n    def parse(payload, meta) do\n      %{lora: %{fport: port}} = meta\n      <<battery::16, temperature::float-32>> = payload\n\n      %{\n        battery: battery,\n        temperature: temperature,\n        port: port,\n        raw: Base.encode16(payload)\n      }\n    end\n\n    # Example payload: \"002B406EA710\"\n    # Output:\n    # {\n    #   \"battery\": 43,\n    #   \"temperature\": 3.7289466857910156,\n    #   \"raw\": \"002B406EA710\",\n    #   \"port\": 1\n    # }\n  end")])], 1), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-top": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DeviceDriver.quickReference.functionHelpTextExParser2'))
    }
  }), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DeviceDriver.quickReference.functionHelpTextUrlParser'))
    }
  }), _c('div', [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{\n    \"payload\": \"112233\",\n    \"parser\": null,\n    \"meta\": {\n      \"source_time\": \"2022-05-11T08:00:15.351444Z\",\n      \"lora\": {\n        \"fport\": 1\n      },\n      \"device_type_id\": -1,\n      \"device_id\": -1\n    }\n  }")])], 1), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-top": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DeviceDriver.quickReference.functionHelpTextUrlParser2'))
    }
  }), _c('div', [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{ \n    \"error\": false, \n    \"result\": { .. parsed object .. } \n  }")])], 1), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-top": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DeviceDriver.quickReference.virtualDevicesHelpText'))
    }
  }), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DeviceDriver.quickReference.functionHelpTextReturnStruc1'))
    }
  }), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DeviceDriver.quickReference.virtualDevicesImportantNote'))
    }
  }), _c('div', [_c('custom-code', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "block": ""
    }
  }, [_vm._v("module.exports = function (payload, meta) {\n    return [\n      {\n        battery: battery[0],\n        temperature: temperature[0],\n        meta: {\n          time: \"2024-01-01T12:34:56Z\"\n        },\n      },\n      {\n        battery: battery[1],\n        temperature: temperature[1],\n        meta: {\n          time: \"2024-01-01T12:34:56Z\"\n        },\n      }\n    ]\n  }")])], 1), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-top": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DeviceDriver.quickReference.functionHelpTextReturnStruc2'))
    }
  }), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.calcluateHelpText'))
    }
  }), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.variablesHelpText'))
    }
  }), _c('div', {
    staticClass: "mb-8"
  }, [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{ \n    \"gps\": { \n      \"latitude\": null, \n      \"longitude\": null \n    } \n  }")]), _c('custom-code', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("array[0], array[1]")]), _c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{ \n    \"array\": [ \n      null, \n      null \n    ] \n  }")])], 1), _c('h3', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.virtualDevicesMqttWhinb')))]), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.virtualDevicesMqttWhinbIntro'))
    }
  }), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-top": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.virtualDevicesMqttWhinbBlock1'))
    }
  }), _c('custom-code', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "block": ""
    }
  }, [_vm._v("{\n    id: 'CCA0E5FFFE073887',\n    timestamp: new Date().toISOString(),\n    payload: \"0027920998FCE93E000000000000FFFF\",\n    port: 1 // Port is optional\n  }")]), _c('br'), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-bottom": "15px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.virtualDevicesMqttWhinbBlock2'))
    }
  }), _c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{\n    id: 'CCA0E5FFFE073887',\n    timestamp: new Date().toISOString(), // timestamp is optional, default is now\n    payload: { \n      \"pressure\": 777,\n      \"temperature\": 20\n    },\n    port: 1 // Port is optional\n  }")]), _c('br'), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-bottom": "15px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.virtualDevicesMqttWhinbBlock3'))
    }
  }), _c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{\n    id: 'CCA0E5FFFE073887',\n    timestamp: new Date().toISOString(), // timestamp is optional, default is now\n    payload: [\n      { \n        \"pressure\": 777,\n        \"temperature\": 20\n      },\n      { \n        \"pressure\": 888\n      }\n    ],\n    port: 1 // Port is optional\n  }")]), _c('br'), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-bottom": "15px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.virtualDevicesMqttWhinbBlock4'))
    }
  }), _c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{\n    id: 'CCA0E5FFFE073887',\n    timestamp: new Date().toISOString(), // will be overruled by meta\n    payload: [\n      { \n        \"pressure\": 777,\n        \"temperature\": 20,\n        \"meta\": {\n          \"time\": \"2022-09-28T07:22:25.439Z\" // meta overrules timestamp that is set above\n        }\n      },\n      { \n        \"pressure\": 888,\n        \"temperature\": 30,\n        \"meta\": {\n          \"time\": \"2022-09-28T07:20:25.439Z\" // meta overrules timestamp that is set above\n        }\n      }\n    ],\n    port: 1 // Port is optional\n  }")])], 1) : _vm._e(), _vm.callFromDeviceType ? _c(VExpansionPanelContent, [_c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.functionHelpTextJSParser'))
    }
  }), _c('div', [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("module.exports = function (payload, meta) {\n    const port = meta.lora.fport;\n\n    const buf = Buffer.from(payload, 'hex');\n    const battery = buf.readUInt16BE(0);  // parse 2 bytes with offset 0\n    const temperature = buf.readFloatBE(2); // parse 4 bytes with offset 2\n\n    return {\n      battery: battery,\n      temperature: temperature,\n      port: port,\n      raw: payload\n    };\n  }\n\n  /*\n  Example payload: \"002B406EA710\"\n  Output:\n  {\n    \"battery\": 43,\n    \"temperature\": 3.7289466857910156,\n    \"raw\": \"002B406EA710\",\n    \"port\": 1\n  }\n  */")])], 1), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.functionHelpTextExParser1'))
    }
  }), _c('div', [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("defmodule Parser do\n    def parse(payload, meta) do\n      %{lora: %{fport: port}} = meta\n      <<battery::16, temperature::float-32>> = payload\n\n      %{\n        battery: battery,\n        temperature: temperature,\n        port: port,\n        raw: Base.encode16(payload)\n      }\n    end\n\n    # Example payload: \"002B406EA710\"\n    # Output:\n    # {\n    #   \"battery\": 43,\n    #   \"temperature\": 3.7289466857910156,\n    #   \"raw\": \"002B406EA710\",\n    #   \"port\": 1\n    # }\n  end")])], 1), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-top": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.functionHelpTextExParser2'))
    }
  }), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.functionHelpTextUrlParser'))
    }
  }), _c('div', [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{\n    \"payload\": \"112233\",\n    \"parser\": null,\n    \"meta\": {\n      \"source_time\": \"2022-05-11T08:00:15.351444Z\",\n      \"lora\": {\n        \"fport\": 1\n      },\n      \"device_type_id\": -1,\n      \"device_id\": -1\n    }\n  }")])], 1), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-top": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.functionHelpTextUrlParser2'))
    }
  }), _c('div', [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{ \n    \"error\": false, \n    \"result\": { .. parsed object .. } \n  }")])], 1), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.functionHelpTextReturnStruc1'))
    }
  }), _c('div', [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("module.exports = function (payload, meta) {\n    const port = meta.lora.fport;\n\n    const buf = Buffer.from(payload, 'hex');\n    const battery = buf.readUInt16BE(0);  // parse 2 bytes with offset 0\n    const temperature = buf.readFloatBE(2); // parse 4 bytes with offset 2\n\n    return {\n      meta: {\n        time: \"2020-01-01T12:34:56Z\",\n        tags: \"tag1, tag2, tag3\"\n      },\n      value: {\n        battery: battery,\n        temperature: temperature,\n        port: port,\n        raw: payload\n      }\n    };\n  }")])], 1), _c('div', {
    class: _vm.modeClass,
    staticStyle: {
      "margin-top": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.functionHelpTextReturnStruc2'))
    }
  }), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.calcluateHelpText'))
    }
  }), _c('div', {
    class: _vm.modeClass,
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.variablesHelpText'))
    }
  }), _c('div', {
    staticClass: "mb-8"
  }, [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{ \n    \"gps\": { \n      \"latitude\": null, \n      \"longitude\": null \n    } \n  }")]), _c('custom-code', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("array[0], array[1]")]), _c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("{ \n    \"array\": [ \n      null, \n      null \n    ] \n  }")])], 1)]) : _vm._e()], 1)], 1), !_vm.switchParserMode ? _c(VExpansionPanels, {
    staticClass: "my-4 dt-card-text-01 parser-elements",
    attrs: {
      "flat": ""
    },
    model: {
      value: _vm.parserCodeExpansion,
      callback: function ($$v) {
        _vm.parserCodeExpansion = $$v;
      },
      expression: "parserCodeExpansion"
    }
  }, [_c(VExpansionPanel, {
    attrs: {
      "data-cy": "fn-parser-panel"
    }
  }, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserHeader')) + "\n            ")])]), _c(VExpansionPanelContent, [_c('core-script-editor', {
    attrs: {
      "script": _vm.scriptEditorValue,
      "script-type": _vm.parserConfigInternal.scriptType,
      "scriptParamsTransformer": _vm.scriptParamsTransformer,
      "readonly": _vm.readonly,
      "evaluationFunction": _vm.testParserFunction
    },
    on: {
      "update:script": _vm.onScriptChange,
      "update:script-type": _vm.changedScriptType
    },
    scopedSlots: _vm._u([{
      key: "additional-fields",
      fn: function () {
        return [_c(VRow, {
          attrs: {
            "align": "center"
          }
        }, [_c(VCol, {
          attrs: {
            "cols": "6",
            "md": "3",
            "lg": "2"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.loraFramePort')) + "\n                  ")]), _c(VCol, [_c(VTextField, {
          attrs: {
            "data-cy": "lora_framePort",
            "name": "loraFramePort",
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "rules": [_vm.rules.required],
            "value": 0,
            "type": "number",
            "hide-details": "auto",
            "autocomplete": "off",
            "disabled": _vm.readonly,
            "required": "",
            "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.loraFramePort')
          }
        })], 1)], 1)];
      },
      proxy: true
    }], null, false, 3334997193)
  })], 1)], 1)], 1) : _vm._e(), _c('niota-classic-devicetypes-packet-parser-calculation', {
    attrs: {
      "switchParserMode": _vm.switchParserMode,
      "calculate-elements": _vm.parserConfigInternal.calculateElements,
      "readonly": _vm.readonly
    },
    on: {
      "config-updated": _vm.onCalculationChange,
      "validate-form": function ($event) {
        return _vm.$refs.form.validate();
      }
    }
  }), _c('niota-classic-devicetypes-packet-parser-type-definitions', {
    attrs: {
      "variables": _vm.parserConfigInternal.variables,
      "custom": _vm.parserConfigInternal.custom,
      "calculate-elements": _vm.parserConfigInternal.calculateElements,
      "parse-elements": _vm.parserConfigInternal.parseElements,
      "readonly": _vm.readonly
    },
    on: {
      "variables-updated": _vm.onTypeDefinitionsUpdated
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };